// Import external
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

@Component({

    selector: 'syn-select-input',
    templateUrl: 'select-input.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SelectInputComponent), multi: true }
    ]
})
export class SelectInputComponent implements ControlValueAccessor {

    @Input() required = false;

    @Input() public data: string[] = ['BUILDING', 'RELEASED', 'CLOSED', // TODO need to add search of differents status
        'UNPROVISIONED', 'UNPROVISIONING'];

    @Input() public disabledOptions: string[] = [];

    @Input() public disabledMessage = '(Option indisponible)';

    @Input() placeholder: any;

    public latestChangeEvent: MatSelectChange;
    public floatPlaceholder = 'auto';

    private _options: string;

    constructor() {
    }

    @Input('options')
    get options() {
        return this._options;
    }

    set options(val) {
        this._options = val;
        this.onChange(val);
        this.onTouched();
    }

    // these functions will be registered later
    onChange: any = () => { };
    onTouched: any = () => { };
    validateFn: any = () => { };

    writeValue(value) {
        if (value) {
            this.options = value;
        }
    }

    registerOnChange(fn) {
        this.onChange = fn;
    }

    registerOnTouched(fn) {
        this.onTouched = fn;
    }

    validate(c: FormControl) {
        return this.validateFn(c);
    }
}
